export class Message {
    author: string;
    authorDisplayName: string;
    content: any;
    todayDate: Date;
    showLoader: boolean;
    botReply: string[] = [];
    chatId: any;
    stopCursor: any;
    type: any;
}

export class Ticket {
    incidentNumber: string;
    shortDescription: string;
    Description: string;
    emailText: string;
    logs: string;
}

export class PromptButton {
    buttonTxt: string;
    message: string;
    displayMessage: string;
    action: string;
    context: string;
}

export class SystemPrompt {
    system_prompt: string;
    prompt: string;
    history: any;
    parameters: any;
}

export class ContextRequest {
    message: string = '';
    action: string;
    context: string;
    context_object: ContextObject[] = [];
}

export class Context {
    name: string;
    maintain = false;
}

export class ContextObject {
    history: History[] = [];
    incident: Incident;
    issue: Issue;
    type: string;
    resolution: Resolution;
}

export class Resolution {
    identified: boolean;
    steps: string;
    source: string;
}

export class Incident {
    number: string;
    description_short: string;
    description_long: string;
    conversation: string;
    error_logs: string;
}

export class History {
    answer: string;
    prompt: string;
}

export class Issue {
    identified: boolean;
    identified_as: string;
}

export class System {
    type: string;
    client: string;
    service_type: string;
}